// src/components/FornecedorLayout.jsx

import React, {useState} from 'react';
import {Outlet} from 'react-router-dom';
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Drawer,
    Box,
    Divider,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    useTheme,
    useMediaQuery,
    Avatar,
    Menu,
    MenuItem,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import {Link, useNavigate} from 'react-router-dom';

// Logo do Fornecedor
import fornecedorLogo from '../../assets/images/itup_logo.png';

import HomeIcon from '@mui/icons-material/Home';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import WorkIcon from '@mui/icons-material/Work';
import {getUserData} from '../../services/GetUserData';

export default function FornecedorLayout({children, user}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [mobileOpen, setMobileOpen] = useState(false);
    const userData = getUserData();
    // Estado para abrir/fechar o menu do usuário
    const [anchorElUser, setAnchorElUser] = useState(null);

    const navigate = useNavigate();

    const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

    // Abre o dropdown de usuário
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    // Fecha o dropdown de usuário
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    // Lógica de logout (neste exemplo, apenas redireciona para /login)
    const handleLogout = () => {
        handleCloseUserMenu();
        navigate('/login');
    };

    const drawerWidth = 220;
    const drawerContent = (
        <Box>
            <Toolbar>
                <Box sx={{textAlign: 'center', width: '87%'}}>
                    <img
                        src={fornecedorLogo}
                        alt="Fornecedor Logo"
                        style={{
                            width: '100%',
                            height: 'auto',
                            marginLeft: '-8%',
                            marginTop: '7%',
                        }}
                    />
                </Box>
            </Toolbar>
            <Divider />
            <List>
                <ListItemButton
                    component={Link}
                    to="/inicio"
                    onClick={() => isMobile && setMobileOpen(false)}
                >
                    <ListItemIcon>
                        <HomeIcon sx={{color: '#111928', opacity: 0.7}} />
                    </ListItemIcon>
                    <ListItemText
                        sx={{color: '#111928', fontSize: '16px', fontWeight: 500}}
                        primary="Início"
                    />
                </ListItemButton>

                <ListItemButton
                    component={Link}
                    to="/ordem-servico"
                    onClick={() => isMobile && setMobileOpen(false)}
                >
                    <ListItemIcon>
                        <AssignmentIcon sx={{color: '#111928', opacity: 0.7}} />
                    </ListItemIcon>
                    <ListItemText
                        sx={{color: '#111928', fontSize: '16px', fontWeight: 500}}
                        primary="Painel OS"
                    />
                </ListItemButton>

                {/* <ListItemButton
                    component={Link}
                    to="/solicitacao"
                    onClick={() => isMobile && setMobileOpen(false)}
                >
                    <ListItemIcon>
                        <WorkIcon sx={{color: '#111928', opacity: 0.7}} />
                    </ListItemIcon>
                    <ListItemText
                        sx={{color: '#111928', fontSize: '16px', fontWeight: 500}}
                        primary="Ordem de Serviço"
                    />
                </ListItemButton> */}

                <ListItemButton
                    component={Link}
                    to="/notas-pagamento"
                    onClick={() => isMobile && setMobileOpen(false)}
                >
                    <ListItemIcon>
                        <ReceiptLongIcon sx={{color: '#111928', opacity: 0.7}} />
                    </ListItemIcon>
                    <ListItemText
                        sx={{color: '#111928', fontSize: '16px', fontWeight: 500}}
                        primary="Notas de Pagamento"
                    />
                </ListItemButton>

                {/* Mantenha ou adicione outros itens de menu aqui */}
            </List>
        </Box>
    );

    return (
        <Box sx={{display: 'flex', width: '100%', overflowX: 'hidden'}}>
            {/* SIDEBAR */}
            {isMobile ? (
                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{keepMounted: true}}
                    sx={{
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                        },
                    }}
                >
                    {drawerContent}
                </Drawer>
            ) : (
                <Drawer
                    variant="permanent"
                    sx={{
                        'width': drawerWidth,
                        'flexShrink': 0,
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                            borderRight: '1px solid #ddd',
                        },
                    }}
                >
                    {drawerContent}
                </Drawer>
            )}

            {/* CONTEÚDO PRINCIPAL */}
            <Box
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh',
                    width: {xs: '100%', sm: `calc(100% - ${drawerWidth}px)`},
                    overflowX: 'hidden',
                }}
            >
                {/* BARRA SUPERIOR */}
                <AppBar
                    position="static"
                    elevation={0}
                    sx={{
                        backgroundColor: '#ffffff',
                        color: '#111928',
                        borderBottom: '1px solid #ddd',
                    }}
                >
                    <Toolbar sx={{display: 'flex', justifyContent: 'space-between'}}>
                        {isMobile && (
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                edge="start"
                                onClick={handleDrawerToggle}
                                sx={{mr: 2, display: {sm: 'none'}}}
                            >
                                <MenuIcon />
                            </IconButton>
                        )}

                        <Typography
                            variant="subtitle1"
                            sx={{color: '#3C5CCB', fontWeight: 700, fontSize: '18px'}}
                        >
                            Olá, {userData?.name || 'Fornecedor'}
                        </Typography>

                        <Box sx={{display: 'flex', alignItems: 'center'}}>
                            {/* Ícone de usuário */}
                            <IconButton onClick={handleOpenUserMenu} sx={{p: 0}}>
                                <Avatar
                                    sx={{
                                        bgcolor: '#3C5CCB',
                                        width: 32,
                                        height: 32,
                                        fontSize: '16px',
                                    }}
                                >
                                    T
                                </Avatar>
                            </IconButton>

                            {/* Dropdown menu do usuário */}
                            <Menu
                                anchorEl={anchorElUser}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                PaperProps={{
                                    sx: {
                                        mt: 1,
                                        minWidth: 120,
                                        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
                                    },
                                }}
                            >
                                <MenuItem onClick={handleLogout} sx={{gap: 1}}>
                                    <ExitToAppIcon fontSize="small" />
                                    Sair
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Toolbar>
                </AppBar>

                {/* ÁREA DE CONTEÚDO */}
                <Box sx={{flexGrow: 1, p: 3, backgroundColor: '#fafafa', overflowX: 'hidden'}}>
                    {children}
                </Box>
            </Box>
        </Box>
    );
}
